function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 66,
    viewBox: "0 0 194 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0.0370897 12.055C0.0370897 8.60315 0.110019 5.15134 0.00276999 1.70368C-0.0444196 0.265774 0.508986 -0.0367256 1.84317 0.0295756C3.69643 0.124884 5.55828 0.0420071 7.41583 0.0544385C11.2554 0.0875891 13.3145 2.0932 13.3317 5.87237C13.3531 10.2897 13.3017 14.707 13.3446 19.1243C13.4861 34.7548 23.027 47.1117 38.0205 51.1312C58.6809 56.6715 79.7146 41.3352 79.8176 20.6368C79.8476 14.4252 79.8691 8.21363 79.7876 2.00204C79.7704 0.530978 80.0407 -0.115458 81.7438 0.0171441C83.803 0.174609 85.8879 -0.00357501 87.9557 0.0751577C90.7098 0.178753 93.0822 2.14707 93.0521 4.7411C92.9706 12.7304 93.7643 20.7528 92.2714 28.7007C88.0157 51.3426 65.206 67.6195 41.6326 64.8183C17.3214 61.9259 0.281618 43.287 0.0413797 19.3025C0.0156399 16.8867 0.0413797 14.4708 0.0413797 12.055H0.0370897Z",
    fill: "#FCC226",
    style: {
      fill: "#FCC226",
      fill: "color(display-p3 0.9882 0.7608 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.941 64.6857C134.437 64.6857 127.934 64.6111 121.43 64.7313C119.581 64.7644 119.096 64.2133 119.251 62.535C119.401 60.8899 119.277 59.2241 119.285 57.5666C119.311 53.7791 121.319 51.7942 125.205 51.8149C136.209 51.8688 147.213 51.9641 158.221 52.0387C163.571 52.076 168.59 50.9447 172.923 47.7789C181.854 41.2565 182.618 28.1371 174.6 19.9241C170.362 15.5813 165.128 13.352 158.972 13.3022C150.182 13.2318 141.391 13.2857 132.597 13.2774C128.393 13.2732 126.462 11.3919 126.445 7.32269C126.437 5.45797 126.458 3.59325 126.441 1.73267C126.432 0.953631 126.544 0.431509 127.582 0.452228C139.65 0.69257 151.795 -0.48842 163.776 0.978494C176.513 2.53657 185.595 9.67638 190.434 21.1548C195.106 32.2271 194.107 42.9969 186.269 52.5733C179.585 60.7407 170.344 64.2133 159.804 64.5696C153.523 64.781 147.226 64.6069 140.937 64.6069C140.937 64.6318 140.937 64.6567 140.937 64.6815L140.941 64.6857Z",
    fill: "#FCC226",
    style: {
      fill: "#FCC226",
      fill: "color(display-p3 0.9882 0.7608 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9803 30.7105C99.9803 21.2626 100.019 11.8105 99.9417 2.36257C99.9288 0.800346 100.358 0.319662 101.958 0.435689C103.876 0.572435 105.81 0.435689 107.741 0.477127C111.091 0.543428 113.266 2.58219 113.271 5.78951C113.296 24.8967 113.271 43.9997 113.314 63.1069C113.314 64.3956 112.94 64.7893 111.628 64.7147C109.779 64.6111 107.917 64.6981 106.059 64.6857C102.022 64.665 99.9932 62.7257 99.9889 58.8512C99.9803 49.4696 99.9889 40.0921 99.9889 30.7105H99.9803Z",
    fill: "#FCC226",
    style: {
      fill: "#FCC226",
      fill: "color(display-p3 0.9882 0.7608 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0232 18.9669C60.4398 19.5305 60.118 20.2971 60.1352 21.0927C60.1352 21.188 60.1352 21.2875 60.1352 21.3828C60.1352 29.8652 52.6835 36.7025 43.769 36.1016C36.2444 35.5919 30.1483 29.7077 29.625 22.4394C29.0029 13.8286 36.0771 6.63075 44.8629 6.63075C46.2529 6.63075 47.6042 6.81308 48.8826 7.15287C49.9465 7.43465 51.0877 7.16116 51.8684 6.40698L55.6736 2.73141C52.1516 0.821104 48.0461 -0.189989 43.6789 0.0296338C32.5464 0.597338 23.486 9.22892 22.7696 19.978C21.903 33.002 33.1856 43.7677 46.7162 42.6945C57.4239 41.8491 66.0339 33.5117 66.9219 23.1729C67.1879 20.0733 66.7546 17.1022 65.7722 14.3756L61.0189 18.9669H61.0232Z",
    fill: "#FCC226",
    style: {
      fill: "#FCC226",
      fill: "color(display-p3 0.9882 0.7608 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7752 6.78824L64.6997 2.8516C63.5114 1.70376 61.5895 1.70376 60.4012 2.8516L44.9101 17.815L38.6425 11.7608L32.4177 17.7735L38.6339 23.8774L44.8586 29.8901L44.9101 29.8403L44.9616 29.8901L51.1863 23.8774L51.1349 23.8276L68.7752 6.78824Z",
    fill: "#FCC226",
    style: {
      fill: "#FCC226",
      fill: "color(display-p3 0.9882 0.7608 0.1490)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanLogo);
export default __webpack_public_path__ + "static/media/dan-logo.1a912fd9a0792bd4ae555fda0e7d47a9.svg";
export { ForwardRef as ReactComponent };